import { gql } from '@apollo/client'

export default gql(`
    mutation($contents: [CreatePublishRuleInput] $project: String) {
        batchCreatePublishRule(
          input: $contents 
          project: $project 
        ) {
            id
            assetId
            group{
              id
            }
            isEnabled
            publishEndDate
            publishStartDate
          }
    }`
)
